import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const SessionCloseWarning: React.FC<{ onLogout: () => void }> = ({ onLogout }) => {
    const location = useLocation();
    const ignoreUnload = useRef(false);

    useEffect(() => {
        ignoreUnload.current = true;
    }, [location]);

    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (ignoreUnload.current) {
                ignoreUnload.current = false; // reset
                return; // skip popup on internal navigation
            }
            e.preventDefault();
            e.returnValue = '';
            return '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [onLogout]);

    return null;
};

export default SessionCloseWarning;
